import React, { useState, useRef, useEffect } from 'react';

const CustomUnitDropdown = ({ userId, units = [], userOptions, setUserOptions }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const userEntry = userOptions[userId] || {};
  const selected = userEntry.unit_ids || [];
  const isUnitSelected = userEntry.unitType === true;

  const allUnitValues = units.map((lvl) => lvl.value);
  const areAllUnitsSelected = allUnitValues.every((lvl) => selected.includes(lvl));

  const handleToggle = () => setOpen(!open);

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const updateSelection = (newSelection, unitType) => {
    setUserOptions((prev) => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        unit_ids: newSelection,
        unitType
      }
    }));
  };

  const handleSelectAllUnits = () => {
    if (areAllUnitsSelected) {
      updateSelection([], false);
    } else {
      updateSelection(allUnitValues, true);
    }
  };

  const handleLevelToggle = (value) => {
    const newSelection = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    updateSelection(newSelection, newSelection.length > 0);
  };

  return (
    <div className="relative w-full " ref={dropdownRef}>
      <label className="text-gray-600 mb-1 block">Units</label>
      <div
        onClick={handleToggle}
        className={`border border-gray-300 px-3 py-2 rounded cursor-pointer bg-white ${selected.length === 0 ? 'text-gray-400' : 'text-gray-600 font-semibold'}`}>
        {selected.length === 0
          ? 'Select Units'
          : selected
              .map((val) => {
                const level = units.find((lvl) => lvl.value === val);
                return level ? level.label : val;
              })
              .join(', ')}
      </div>

      {open && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 rounded mt-1 max-h-[8rem] overflow-y-auto shadow-lg">
          <div className="p-2">
            <button
              className="text-blue-500 text-sm mb-2 underline disabled:text-gray-400"
              onClick={handleSelectAllUnits}
              disabled={false}>
              {areAllUnitsSelected ? 'Deselect All Units' : 'Select All Units'}
            </button>

            {units.map((lvl) => (
              <label key={lvl.value} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={selected.includes(lvl.value)}
                  onChange={() => handleLevelToggle(lvl.value)}
                />
                {lvl.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomUnitDropdown;
